import type {FC, MouseEventHandler, ReactNode} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {AlertFillIcon} from '~library/svg/AlertFillIcon';
import {XIcon} from '~library/svg/v2/XIcon';

import {error} from '~libSass/v2/_exports.sass';
import './Feedback.sass';

interface FeedbackProps {
  message: string;
  onClose?: MouseEventHandler<HTMLButtonElement>;
  endAdornment?: ReactNode;
}

export const Feedback: FC<FeedbackProps> = ({message, onClose, endAdornment}) => {
  return (
    <div className="design-error-alert">
      <AlertFillIcon color={error} ratio={0.5} />
      <Typography variant="paragraph3" className="design-error-alert__text">
        {message}
      </Typography>
      {endAdornment ?? (
        <Button data-qa-id="dismiss-design-error" variant="unstyled-button" onClick={onClose}>
          <XIcon ratio={0.5} />
        </Button>
      )}
    </div>
  );
};
